import React from "react";
import appPath from "utils/appPath";
import styles from "./styles.module.scss";

export default function ScreenContainer(Component, { hasMultipleScreens } = {}) {
    return (props) => {
        const className = hasMultipleScreens || appPath.isIframePath()
            ? ""
            : styles.container;

        return (
            <main className={ className }>
                <Component { ...props } />
            </main>
        );
    };
}
